import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { BaseDataReducerInitialState, basedDataReducer } from 'redux/base-reducer';

import { IEecsTransaction, IEecsTransactionModal } from '../types/eecs-transaction.type';

interface EecsTransactionInitialState extends BaseDataReducerInitialState<IEecsTransaction> {
  perPage: number;
  selectedTransaction: IEecsTransaction | null;
  currentModal: IEecsTransactionModal | null;
}

const { initialState, AC, reducer, thunks } = basedDataReducer<IEecsTransaction, EecsTransactionInitialState>(
  'necs-transaction',
);

const eecsTransactionInitialState: EecsTransactionInitialState = {
  ...initialState,
  perPage: 25,
  selectedTransaction: null,
  currentModal: null,
};

export const eecsTransaction = createSlice({
  name: 'eecsTransaction',
  initialState: eecsTransactionInitialState,
  reducers: {
    setSelectedEecsTransaction: (state, action: PayloadAction<IEecsTransaction | null>) => {
      state.selectedTransaction = action.payload;
    },
    setEecsTransactionModal: (state, action: PayloadAction<IEecsTransactionModal | null>) => {
      state.currentModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addDefaultCase((state, action) => {
      return reducer(state as EecsTransactionInitialState, action);
    });
  },
});

export const EecsTransactionAC = AC;
export const onEecsTransactionSort = thunks.onSort;
export const onEecsTransactionFilter = thunks.onFilter;
export const setEecsTransactionCurrentPage = AC.setCurrentPage;

export const { setSelectedEecsTransaction, setEecsTransactionModal } = eecsTransaction.actions;
